export default __webpack_public_path__ + "static/media/forbidden.05fdb0a4.svg";